// extracted by mini-css-extract-plugin
export default {"card":"HoverImage_card__7oyUB","CardImg":"HoverImage_CardImg__4gmj8","CarBody":"HoverImage_CarBody__Le4iw","CardBtn":"HoverImage_CardBtn__sWyfl"};